import script from "./BlogOnWebsView.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogOnWebsView.vue?vue&type=script&setup=true&lang=js"

import "./BlogOnWebsView.vue?vue&type=style&index=0&id=3bf6236f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bf6236f"]])

export default __exports__